import * as Constants from '../../constants';
import Api from '../../lib/Api';

export function annotateObjects({ listener, pandoraIds, annotateAlbumTracks = true }) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.CATALOG_ANNOTATE_OBJECTS,
    content: {
      listener,
      pandoraIds,
      annotateAlbumTracks,
    },
    // We'd like this to retry if it fails
    retries: 1,
  });
}

export function annotateObjectsSimple({ listener, pandoraIds }) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.CATALOG_ANNOTATE_OBJECTS_SIMPLE,
    content: {
      listener,
      pandoraIds,
    },
  });
}

export function getDetails({ listener, pandoraId, withCollaborations = false }) {
  return Api.apiRequest({
    endpoint: withCollaborations
      ? Constants.Api.ApiEndpoints.CATALOG_GET_DETAILS_WITH_COLLABORATIONS
      : Constants.Api.ApiEndpoints.CATALOG_GET_DETAILS,
    content: {
      listener,
      pandoraId,
    },
    actionParams: {
      updateEntitiesWith: {
        pandoraId,
      },
    },
  });
}

/**
 * Actions creator to retrieve full lyrics for a track
 *
 * @param {string} trackPandoraId - Track ID for a track
 * @param {boolean} returnExplicit - user setting for explicit
 * @returns {Promise}
 */
export function getFullLyrics({ trackPandoraId, returnExplicit }) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.FETCH_FULL_LYRICS,
    content: {
      returnExplicit,
      trackPandoraId,
    },
  });
}

export function getArtistDiscography({
  artistPandoraId,
  annotationLimit = 20,
  withCollaborations = false,
}) {
  return Api.apiRequest({
    endpoint: withCollaborations
      ? Constants.Api.ApiEndpoints.CATALOG_GET_ARTIST_DISCOGRAPHY_WITH_COLLABORATIONS
      : Constants.Api.ApiEndpoints.CATALOG_GET_ARTIST_DISCOGRAPHY,
    content: {
      artistPandoraId,
      annotationLimit,
    },
    actionParams: {
      updateEntitiesWith: {
        pandoraId: artistPandoraId,
      },
    },
  });
}

export function getAllArtistTracks({
  artistPandoraId,
  annotationLimit = 20,
  withCollaborations = false,
}) {
  return Api.apiRequest({
    endpoint: withCollaborations
      ? Constants.Api.ApiEndpoints.CATALOG_GET_ALL_ARTIST_TRACKS_WITH_COLLABORATIONS
      : Constants.Api.ApiEndpoints.CATALOG_GET_ALL_ARTIST_TRACKS,
    content: {
      artistPandoraId,
      annotationLimit,
    },
    actionParams: {
      updateEntitiesWith: {
        pandoraId: artistPandoraId,
      },
    },
  });
}

export function sortObjects({ pandoraIds, view }) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.CATALOG_SORT_OBJECTS,
    content: {
      pandoraIds,
      view,
    },
  });
}

export function getArtistEvents({ pandoraId }) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.GET_ARTIST_EVENTS,
    content: {
      pandoraId,
    },
  });
}
